export enum FunctionalReviewResponseItemPriority {
  None,
  P2 = 2,
  P3,
  P4,
}
